import { render, staticRenderFns } from "./NewShopList.vue?vue&type=template&id=0282ec8e&scoped=true&"
import script from "./NewShopList.vue?vue&type=script&lang=js&"
export * from "./NewShopList.vue?vue&type=script&lang=js&"
import style0 from "./NewShopList.vue?vue&type=style&index=0&id=0282ec8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282ec8e",
  null
  
)

export default component.exports